const downloadXmlHelper = (data: string, fileName: string) => {
  const blob = new Blob([data], { type: 'text/xml' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadCsvHelper = (data: number[], fileName: string) => {
  let csvContent = '';
  data.forEach(function (row) {
    csvContent += row + '\n';
  });
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { downloadXmlHelper, downloadCsvHelper };
